/* 🤖 this file was generated by svg-to-ts */
export const emperorIconMegaphone: {
  name: 'megaphone';
  data: string;
} = {
  name: 'megaphone',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path fill="none" d="M0 0h24v24H0Z"/><g><path d="M20 3V4.197L4 7.754V7H2V15H4V14.246L5 14.469V18C5 18.459 5.313 18.858 5.757 18.971L9.757 19.971C9.838 19.99 9.919 20 10 20C10.31 20 10.607 19.855 10.799 19.6L13.27 16.307L20 17.801V19H22V3H20ZM9.598 17.869L7 17.219V14.912L11.127 15.83L9.598 17.869ZM4 12.197V9.803L20 6.246V15.754L4 12.197Z"/></g></svg>`,
};
